import React from "react";
// internal
import SingleFaq from "components/faqs/single-faq";
import { PlayThree } from "svg/index";
import faq_bg from "assets/img/Main Images/Home/faq-img3.png";
import VideoModal from "components/common/modals/modal-video";
import useModal from "hooks/use-modal";

const faq_items = [
  {
    id: "about-one",
    title: "Can I cancel my account at any time?",
    show: true,
    desc: "Non similique culpa in provident quos sit commodi beatae ea laborum suscipit id autem velit aut iusto odio et deleniti quis et doloremque enim vel consequuntur quos.",
    parent: "faqaccordion",
  },
  {
    id: "about-two",
    title: "What happens after the license expires?",
    desc: "Non similique culpa in provident quos sit commodi beatae ea laborum suscipit id autem velit aut iusto odio et deleniti quis et doloremque enim vel consequuntur quos.",
    parent: "faqaccordion",
  },
  {
    id: "about-three",
    title: "Does Harry have any documentations?",
    desc: "Non similique culpa in provident quos sit commodi beatae ea laborum suscipit id autem velit aut iusto odio et deleniti quis et doloremque enim vel consequuntur quos.",
    parent: "faqaccordion",
  },
];

const AboutFaqs = ({ element_faq = false, title, head, desc }) => {
  const { isVideoOpen, setIsVideoOpen } = useModal();
  return (
    <React.Fragment>
      <section className="faq__area p-relative">
        <div
          className="faq__video"
          style={{ backgroundImage: `url(${faq_bg})` }}
        >
          <div className="faq__video-btn">
            <a
              style={{ cursor: "pointer" }}
              onClick={() => setIsVideoOpen(true)}
              className="tp-pulse-border popup-video"
            >
              <PlayThree />
            </a>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row justify-content-end">
            <div className="col-xxl-7 col-xl-7 col-lg-7">
              <div className="faq__wrapper-2 faq__gradient-border faq__style-2 tp-accordion pl-160">
                <div className="faq__title-wrapper">
                  <span className="faq__title-pre">
                    {/* {element_faq
                      ? "Minimal Design"
                      : "Get in touch with us to see how"} */}
                      {head}
                  </span>
                  <h3 className="faq__title">
                  {title}
                    {/* {element_faq
                      ? "Accordion with image"
                      : "Provide smart and flexible digital services"} */}
                  </h3>
                </div>
                <div className="accordion" id="faqaccordion">
                  {/* {faq_items.map((item) => (
                    <SingleFaq key={item.id} item={item} />
                  ))} */}
                  {desc}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* video modal start */}
      <VideoModal
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={""}
      />
      {/* video modal end */}
    </React.Fragment>
  );
};

export default AboutFaqs;
